<template>
  <MyCaseSectionCore>
    <template
      v-if="Object.keys(safeRentForLongerItemsByReturnDate).length > 0"
      #body>
      <div
        v-for="(key, index) in Object.keys(safeRentForLongerItemsByReturnDate)"
        :key="key"
        class="mt-md">
        <h6 class="ms-md">
          Rental Ends {{ key }}
        </h6>
        <CaseItem
          v-for="packageItem in safeRentForLongerItemsByReturnDate[key]"
          :key="packageItem.id"
          class="p-md"
          :package-item="packageItem"
          :show-return-button="true"
          :show-rent-quarterly-button="isItemEligibleForQuarterlyRental(packageItem)"
          :show-review-button="false"/>
        <hr
          v-if="index < Object.keys(safeRentForLongerItemsByReturnDate).length - 1"
          class="m-0">
      </div>
    </template>
    <template
      v-else
      #body>
      <div class="m-lg bold">
        <div class="rent-quarterly-image-container shadow-primary">
          <img
            :src="onboardingImage"
            :alt="onboardingImageAlt">
        </div>
        <h4 class="text-plum text-center text-capitalize">
          Don’t want to give it up? <br> Rent Quarterly.
        </h4>
        <p class="text-center">
          Rent favorites for 3 months at a time for just $10/month.
        </p>
        <div class="bg-origami adorn-border-radius p-lgp mt-lgp text-center">
          <p>
            Go to the
            <BaseButton
              text="With You"
              class="text-link text-orchid p-0"
              @click="selectWithYouTab"/>
            tab and click "Rent Quarterly" on any item.
          </p>
        </div>
      </div>
    </template>
  </MyCaseSectionCore>
</template>

<script setup>
import MyCaseSectionCore from '@/components/case/common/MyCaseSectionCore.vue'
import CaseItem from '@/components/case/caseItem/CaseItem.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useQuarterlyRentalsStore } from '@/stores/quarterlyRentals.js'
import { useCaseStore } from '@/stores/case.js'

const quarterlyRentalsStore = useQuarterlyRentalsStore()
const caseStore = useCaseStore()
const { rentForLongerItemsByReturnDate } = storeToRefs(quarterlyRentalsStore)
const { isItemEligibleForQuarterlyRental } = quarterlyRentalsStore

const safeRentForLongerItemsByReturnDate = computed(() => {
  return rentForLongerItemsByReturnDate.value || {}
})

function selectWithYouTab() {
  caseStore.setCoreTabById('with-you')
}

const onboardingImage = 'https://d2ezpplblfgpjx.cloudfront.net/RentQuarterly.jpg'
const onboardingImageAlt = 'Rent Quarterly'

</script>

<style lang="scss" scoped>
:deep(.section) {
  padding: 0;
}
:deep(.section.mobile) {
  padding: 0;
}
.rent-quarterly-image-container {
  padding: $spacing-md;
  background-color: $white;
  border-radius: $sequin-border-radius;
  width: 80%;
  margin: 0 auto $spacing-lgp auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>